<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Collection Bundle ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-4 pt-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-text-field
              label="Name"
              v-model.trim="model.name"
              class="mr-2"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-text-field
              label="Key"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
        </v-expansion-panels>
        <v-row dense class="mt-6"/>
        <v-expansion-panels>
          <r-panel title="Sale Config">
            <v-row dense>
              <v-col cols="4" md="4" sm="4">
                <v-text-field v-model.number="model.saleDuration" label="Sale Duration" hide-details/>
              </v-col>
            </v-row>
            <v-row dense class="mb-4 pt-4">
              <r-currency-table :items="model.cardPrice" title="Card Price"/>
            </v-row>
          </r-panel>
          <r-card-panel :items.sync="model.previewCards" title="Preview Cards"/>
          <r-card-album-panel :items.sync="model.albums" title="Albums"/>
          <r-reward-bunch-panel :model.sync="model.rewardBunch" title="Rewards"/>
          <r-product-panel :items.sync="model.shopDuplicate" title="Shop Duplicate" :kinds="product_groups"/>
          <r-product-panel :items.sync="model.shopCardpack" title="Shop Cardpack" :kinds="product_groups"/>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {SmartOfferBundleCollection} from "@/modules/redactor/models/smart-offer/bundle-collection/SmartOfferBundleCollection";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RRewardBunchPanel from "@/modules/redactor/views/reward/r-reward-bunch-panel.vue";
import RCardAlbumPanel from "@/modules/redactor/views/card-album/r-card-album-panel.vue";
import RCardPanel from "@/modules/redactor/views/card/r-card-panel.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCurrencyTable from "@/modules/redactor/views/currency/r-currency-table.vue";
import RProductPanel from "@/modules/redactor/views/product/r-product-panel.vue";


export default {
  name: "r-smart-offer-bundle-collection",
  components: {RProductPanel, RCurrencyTable, RPanel, RCardPanel, RCardAlbumPanel, RRewardBunchPanel, RGuardMoneyPanel, RGuardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleCollection(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    product_groups() {
      return [ProductGroupKind.CARDS];
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleCollection();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>
